import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AoFilterHeaderField } from '../ao-filter-list-header.component';

/**
 * Column header for string or numeric columns.
 * The header can be used to search for values in the column
 * and sort the values in ascending or descending order.
 */
@Component({
    selector: 'app-filter-input',
    templateUrl: './filter-input.component.html',
    styleUrls: ['./filter-input.component.scss'],
    standalone: false
})
export class FilterInputComponent {
    /**
     * The field for which this filter is used
     */
    @Input() field!: AoFilterHeaderField;
    /**
     * The form control for the filter input
     */
    @Input() control!: UntypedFormControl;
    /**
     * Whether the column is a numeric column
     */
    @Input() isNumber = false;

    /**
     * Emitted when the sort order changed
     */
    @Output() sortChange = new EventEmitter<void>();

    public get sortable() {
        return !!this.field.sortKey;
    }
}
